import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useSidebar } from "../../content/SidebarContent";
import PageHeader from "../../components/PageHeader";
import { routes } from "../../helpers/constants";
import Loader from "../../components/Loader";
import {
  reqToGetStaffDetails,
} from "../../redux/slices.js/staff/staffSlice";

const ViewStaff = () => {
    const { setIsSidebarOpen } = useSidebar();
      const dispatch = useDispatch();
      const navigate = useNavigate();
      const { id } = useParams();
    
      const staffDetails = useSelector((state) => state.staff.staffDetails);
      const loader = useSelector((state) => state.staff.loader);
    
      useEffect(() => {
        dispatch(
          reqToGetStaffDetails({
            id: Number(id),
            onSuccess: () => {},
            onFailure: () => {},
          })
        );
      }, [id, dispatch]);
    
      const initialValues = {
        email: staffDetails.email || "",
        name: staffDetails.name || "",
      };
    

  return (
    <>
      {loader && <Loader />}
      <section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
        <div className="!p-0">
          <div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
            <PageHeader
              title="View Staff"
              description="View staff member information."
              onOpenSidebar={() => setIsSidebarOpen(true)}
            />

            <div className="flex items-baseline gap-[40px] main-sidebar-wrapper flex-1">
              <div className="flex-1 right-sidebar h-full relative">
                <div className="right-sidebar-contend py-6 px-3 md:px-6 h-full">
                  <Formik
                    initialValues={initialValues}
                    enableReinitialize
                  >
                    {({ values, touched, errors }) => (
                      <Form className="signin-form flex flex-col gap-6 h-full">
                        <div className="bg-white box-shadow p-5 space-y-7 rounded-md">
                          <h2 className="text-h4 text-blue">Staff Information</h2>

                          <div className="grid md:grid-cols-2 gap-6">
                            <div>
                              <label htmlFor="name">
                                Full Name <span>*</span>
                              </label>
                              <Field
                                name="name"
                                placeholder="Enter first name"
                                className="w-full"
                                disabled
                              />
                            </div>

                            <div>
                              <label htmlFor="email">
                                Email <span>*</span>
                              </label>
                              <Field
                                name="email"
                                type="email"
                                placeholder="Enter email"
                                className="w-full"
                                disabled
                              />
                            </div>
                          </div>
                        </div>

                        <div className="flex gap-4 mt-auto">
                          <button
                            type="button"
                            className="skip-btn border-blue"
                            onClick={() => navigate(-1)}
                          >
                            Back
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ViewStaff;
